
import { LocalStorageService } from 'angular-web-storage';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { LoginService } from '../../login/login.service';

import { Component, OnInit } from '@angular/core';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { firstValueFrom } from 'rxjs';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { RatesService } from '../_services/rates.service';

@Component({
    selector: 'app-rates-list',
    templateUrl: './rates-list.component.html',
    host: { class: 'list-page' },
    standalone: false
})
export class RatesComponent implements OnInit{
  
  public rates: any = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any = {
    first: 0,
    rows: 0
  };
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public type: string = "";
  public title: string = "";
  constructor(
    private storage: LocalStorageService,
    private messageService: MessageService,    
    private confirmationService: ConfirmationService,                
    private router: Router,
    private topbarService: TopbarService,
    private loginService: LoginService,
    private ratesService: RatesService,
    private route: ActivatedRoute
  ) {
        
  }

  ngOnInit(): void {        

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.type = params.get('type')??''; 
      if(this.type=="COMPANY"){
        this.title="Baremos de compañía";
      }else if(this.type=="WORKER"){
        this.title="Baremos de operador";
      }else if(this.type == "PROVIDER"){
        this.title="Baremos de proveedor";
      }else{
        this.title="Baremos";
      }
      this.topbarService.setTitle(this.title);   
      this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
        this.edit({});
      });
      this.loadData(this.lastGridEvent);
    });
    this.allowWrite = this.loginService.hasPermission(this.type + "_RATES.WRITE");
    this.allowDelete = this.loginService.hasPermission(this.type + "_RATES.DELETE");
    
  }

  async loadData($event: any) {
    
    this.lastGridEvent = $event;

    let params:IParamsCollection = {      
      page: { number: $event.first+1, size: $event.rows },            
    }
    this.filters.typeOfRate = new Filter(FilterOperation.equals,  'typeOfRate', "", this.type=="COMPANY"?'0': this.type=="WORKER"?'1':'2')
    
    
    if(typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.ratesService.all(params));
    this.rates = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }
  
  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(rate: any) {
    //if (this.loginService.hasPermission("RATES_WRITE")) {      
      this.router.navigate(['rates/'+this.type+'/' + (rate && Object.keys(rate).length > 0 ? rate.id : 0)]);
    //}
  }

  delete(rate: any) {    
    if (this.allowDelete) {      
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el baremo?",
        header: "Eliminar baremo",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.ratesService.delete(rate.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Baremo eliminado correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
    }
  }

  getSeverity(active: boolean) {
    if(active){
      return 'success'; 
    }else{
      return 'danger';
    }    
  }
}
